import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import StorefrontLayout from "@/components/StorefrontLayout";

export default function Account() {
  const { user, loading, logout } = useAuth();
  const nav = useNavigate();

  if (loading) return <StorefrontLayout><div className="max-w-md mx-auto p-12 font-mono-ui">Loading…</div></StorefrontLayout>;
  if (!user) { nav("/login"); return null; }

  const initials = (user.name || user.email).slice(0, 2).toUpperCase();
  return (
    <StorefrontLayout>
      <section className="max-w-2xl mx-auto px-6 py-20">
        <div className="label-mono mb-3">/ YOUR ACCOUNT</div>
        <h1 className="font-display text-5xl font-medium tracking-tight">
          Hello, <em className="italic" style={{ color: "var(--accent)" }}>{user.name?.split(" ")[0] || "friend"}</em>.
        </h1>
        <div className="mt-10 bx p-6 flex items-center gap-4">
          {user.picture ? (
            <img src={user.picture} alt="" className="w-14 h-14 rounded-full object-cover" />
          ) : (
            <div className="w-14 h-14 rounded-full flex items-center justify-center font-display font-bold text-xl"
                 style={{ background: "var(--paper-2)" }}>
              {initials}
            </div>
          )}
          <div>
            <div data-testid="account-name" className="font-display text-xl">{user.name}</div>
            <div data-testid="account-email" className="font-mono-ui text-sm" style={{ color: "var(--ink-soft)" }}>{user.email}</div>
          </div>
        </div>
        <div className="mt-6 flex gap-3">
          <button data-testid="account-logout" onClick={async () => { await logout(); nav("/"); }} className="btn-pill">Sign out</button>
          <button onClick={() => nav("/shop")} className="btn-ghost">Browse collection →</button>
        </div>
      </section>
    </StorefrontLayout>
  );
}
